import { render, staticRenderFns } from "./Contributions.vue?vue&type=template&id=4d02b82e&"
import script from "./Contributions.vue?vue&type=script&lang=js&"
export * from "./Contributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports